import { render, staticRenderFns } from "./CustomSewInLabelField.vue?vue&type=template&id=13f9d028&scoped=true&"
import script from "./CustomSewInLabelField.vue?vue&type=script&lang=ts&"
export * from "./CustomSewInLabelField.vue?vue&type=script&lang=ts&"
import style0 from "./CustomSewInLabelField.vue?vue&type=style&index=0&id=13f9d028&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f9d028",
  null
  
)

export default component.exports